import { Box, Grid, GridItem, Text } from '@chakra-ui/react';

import DashboardHomeSkeleton from './DashboardHomeSkeleton';

/**
 * (2635) Layout of the dashboard home. Each section is its own slot, so new
 * sections drop in without touching the page's data or wizard flow:
 *
 *   Dashboard
 *   [ setupProgress                       ]
 *   [ main (account summary) ] [ aside    ]
 *
 * The aside column only exists once something is passed for it.
 *
 * @param {object} props
 * @param {import('react').ReactNode} [props.setupProgress]
 * @param {import('react').ReactNode} props.main
 * @param {import('react').ReactNode} [props.aside]
 * @param {boolean} [props.isLoading] - shows the skeleton in place of every section
 */
// (3159) Capped at the TCAP Concept design's content width. Within it the
// account summary spans the full width whenever there is no aside.
const DASHBOARD_MAX_WIDTH = '1280px';

const DashboardHome = ({ setupProgress, main, aside, isLoading = false }) => (
    <Box
        position="relative"
        width="100%"
        maxWidth={DASHBOARD_MAX_WIDTH}
        minW={0}>
        <Text
            as="h1"
            sx={{
                fontSize: '20',
                fontWeight: '500',
                marginBottom: '15px',
            }}>
            Dashboard
        </Text>
        {isLoading ? (
            <DashboardHomeSkeleton />
        ) : (
            <>
                {setupProgress}
                <Grid
                    templateColumns={
                        aside
                            ? {
                                  base: 'minmax(0, 1fr)',
                                  lg: 'minmax(0, 2fr) minmax(0, 1fr)',
                              }
                            : 'minmax(0, 1fr)'
                    }
                    gap={6}
                    alignItems="start">
                    <GridItem>{main}</GridItem>
                    {aside && <GridItem>{aside}</GridItem>}
                </Grid>
            </>
        )}
    </Box>
);

export default DashboardHome;
